/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetItemsByCategoryQuery } from '../../models/get-items-by-category-query';
import { GetItemsByCategoryQueryResult } from '../../models/get-items-by-category-query-result';

export interface ApiNurseryManagerItemsGetItemsByCategoryPost$Params {
      body?: GetItemsByCategoryQuery
}

export function apiNurseryManagerItemsGetItemsByCategoryPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerItemsGetItemsByCategoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemsByCategoryQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerItemsGetItemsByCategoryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetItemsByCategoryQueryResult>;
    })
  );
}

apiNurseryManagerItemsGetItemsByCategoryPost.PATH = '/api/NurseryManager/Items/GetItemsByCategory';
